import {
  DataTable,
  DataTableSort,
  Grid,
  Text,
} from "@pushpress/shared-components";
import { MemberDataType } from "../../types";
import { joinStrings } from "../../../../utils/misc";
import { useMemo, useState } from "react";
import UserAvatar from "../../../../components/common/UserAvatar/UserAvatar";
import { MemberSortType, sortMembers } from "../../helpers";
import EmptyTableView from "./EmptyTableView";

export default function NoMatchTabView({
  membersData,
}: {
  membersData: MemberDataType[];
}) {
  const hasData = membersData.length > 0;

  const columns = useMemo(
    () => [
      {
        key: "name",
        header: "Name",
        isSortable: true,
        width: "34%",
        widthMobile: "auto",
        cell: (member: MemberDataType) => (
          <Grid
            container
            alignItems="center"
            className={member.parentEmail ? "tw-pl-6" : ""}
          >
            <Grid item>
              <UserAvatar data={member} size="medium" />
            </Grid>
            <Grid item>
              <Text variant="body-lg" color="wolf-800">
                {joinStrings(member.firstName, member.lastName)}
              </Text>
              <Text variant="body-lg" color="wolf-600">
                {member.email || "—"}
              </Text>
            </Grid>
          </Grid>
        ),
      },
      {
        key: "status",
        header: "",
        widthMobile: "auto",
        cell: () => <></>,
      },
    ],
    [],
  );

  const [sort, setSort] = useState<DataTableSort<MemberSortType>>({
    key: "name",
    order: "asc",
  });

  const handleSort = (value: DataTableSort<MemberSortType>) => {
    setSort(value);
  };

  const data = useMemo(() => {
    return sortMembers(membersData, sort, []);
  }, [membersData, sort]);

  return (
    <Grid item md={12} xs={12} marginY={3}>
      {!hasData && <EmptyTableView />}
      {hasData && (
        <DataTable
          data={data}
          columns={columns}
          sort={sort}
          getRowId={(row) => String(row.id)}
          onSort={handleSort}
          loading={false}
        />
      )}
    </Grid>
  );
}
